import React, { useState, useEffect } from 'react';
import { libraryAPI } from '../../../../services/library.service';
import AuthorList from './AuthorList';
import AuthorModal from './AuthorModal';

const AuthorManager = ({ showMessage }) => {
  const [authors, setAuthors] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const response = await libraryAPI.getAuthors();
      setAuthors(response.data?.results || response.data || []);
    } catch (error) {
      console.error('Error loading authors', error);
      if (showMessage) showMessage('Ошибка загрузки авторов', 'error');
    }
  };

  const handleCreate = async (formData) => {
    setLoading(true);
    try {
      const data = new FormData();
      Object.keys(formData).forEach(key => {
        if (formData[key]) data.append(key, formData[key]);
      });

      await libraryAPI.createAuthor(data);
      if (showMessage) showMessage('Автор добавлен!');
      setIsModalOpen(false);
      loadData();
    } catch (error) {
      console.error('Error creating author', error);
      if (showMessage) showMessage('Ошибка при добавлении автора', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-content">
      <div className="content-header">
        <h2>Управление авторами</h2>
        <button className="action-button primary" onClick={() => setIsModalOpen(true)}>
          ➕ Добавить автора
        </button>
      </div>

      <AuthorList authors={authors} />

      <AuthorModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        onSubmit={handleCreate} 
        loading={loading}
      />
    </div>
  );
};

export default AuthorManager;
